<template>
    <section class="countries">
        <div class="marquee-wrapper">
            <div class="marquee-content" v-for="(repeat, index) in 2" :key="index">
                <template v-for="(country, i) in countries" :key="i">
                    <span>{{ country }}</span>
                    <span class="icon" v-if="i < countries.length - 1"> • </span>
                </template>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const countries = computed(() => [
    t("usa"),
    t("greece"),
    t("spain"),
    t("netherlands"),
    t("belgium"),
    t("switzerland"),
    t("romania"),
    t("slovakia"),
    t("lithuania"),
    t("canada"),
    t("denmark"),
    t("portugal"),
    t("poland"),
    t("italy"),
    t("france"),
    t("japan"),
]);
</script>